import React from 'react';

const StepWelcome = ({ nextStep }) => (
  <div className="onboarding-content center">
    <div>
      <h2 className="onboarding-heading large">
        Welcome to <br />
        The&nbsp;Information
      </h2>
      <p className="mt2 mb3">
        We're the leading publication high-powered tech executives and founders read daily.
      </p>
      <button onClick={nextStep} className="button button-red button-stretch button-small">
        Get Started
      </button>
    </div>
  </div>
);

export default StepWelcome;
